import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class Inventory
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	all(callback)
	{
		this.backend.callBackend(`${Endpoints.inventory.private}/all`, callback);
	}

	inventoryDetails(id,callback){
		this.backend.callBackend(`${Endpoints.inventory.private}/giftcardId/${id}`, callback ,"GET");
	}
	getCsvDownloadData(callback){
		this.backend.callBackend(`${Endpoints.inventory.private}/all/download`, callback, "GET");
	}
	brands(callback){
		this.backend.callBackend(`${Endpoints.inventory.brand}/brands`,callback,"GET");
	}
	denomination(id,callback){
		this.backend.callBackend(`${Endpoints.inventory.deno}/brand/${id}`,callback,"GET");

	}
	createThreshold(data,callback){
		this.backend.callBackend(`${Endpoints.inventory.brand}`,callback,"POST",data);
	}
	deleteThreshold(id,callback){
		this.backend.callBackend(`${Endpoints.inventory.brand}/${id}`,callback,"DELETE");
	}
	getAll(callback){
		this.backend.callBackend(`${Endpoints.inventory.brand}/all`,callback,"GET");
	}
	updateThreshold(data,callback){
		this.backend.callBackend(`${Endpoints.inventory.brand}`,callback,"POST",data);
	}
	editGidtcard(currentgifcardId,giftcardId,stock,callback){
		this.backend.callBackend(`${Endpoints.inventory.private}/change-stock?currentGiftCardId=${currentgifcardId}&newGiftCardId=${giftcardId}&quantity=${stock}`,callback,"PATCH");	
	}
	editSupplier(data,callback){
		this.backend.callBackend(`${Endpoints.inventory.private}/change-supplier`, callback, "PATCH",data);
	}
	supplierAll(callback){
		this.backend.callBackend(`${Endpoints.inventory.supplier}/all`, callback, "GET");
	}
}